var _circle, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconListConfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1_",
    fill: "#488BE6",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    fill: "#FFFFFF",
    points: "3.9,8.2 6.5,10.8 11.5,5.8 10.3,4.6 6.5,8.4 5,6.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListConfirmed);
export default __webpack_public_path__ + "static/media/icon-list-confirmed.1f1d5350a8e4f0ecb34724c042827569.svg";
export { ForwardRef as ReactComponent };